import { Link } from "wouter";
import { ChevronRight, Home } from "lucide-react";
import JsonLd from "./JsonLd";

interface Crumb {
  label: string;
  href?: string;
}

interface PageBreadcrumbsProps {
  crumbs: Crumb[];
}

export default function PageBreadcrumbs({ crumbs }: PageBreadcrumbsProps) {
  const allCrumbs: Crumb[] = [{ label: "Home", href: "/" }, ...crumbs];

  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": allCrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.label,
      ...(crumb.href ? { "item": `https://turkeyvacationguide.com${crumb.href}` } : {}),
    })),
  };

  return (
    <>
      <JsonLd data={jsonLdData} />
      <nav aria-label="Breadcrumb" className="container mx-auto px-4 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-gray-500">
          {allCrumbs.map((crumb, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && <ChevronRight className="h-3 w-3 mx-1 text-gray-400" />}
              {crumb.href && index < allCrumbs.length - 1 ? (
                <Link
                  href={crumb.href}
                  className="hover:text-[#E30A17] transition flex items-center gap-1"
                >
                  {index === 0 && <Home className="h-3 w-3" />}
                  {crumb.label}
                </Link>
              ) : (
                <span className={index === allCrumbs.length - 1 ? "text-gray-700 font-medium" : ""}>
                  {index === 0 && <Home className="h-3 w-3 inline mr-1" />}
                  {crumb.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
